export const userInputs = [
    {
        id: 1,
        label: "Username",
        type: "text",
        placeholder: "its-kaushik",
    },
    {
        id: 2,
        label: "Full Name",
        type: "text",
        placeholder: "Mayank Kaushik",
    },
    {
        id: 3,
        label: "Email",
        type: "mail",
        placeholder: "kaushik@gmail.com",
    },
    {
        id: 4,
        label: "Phone",
        type: "text",
        placeholder: "+91 9811723348",
    },
    {
        id: 5,
        label: "Password",
        type: "password",
    },
    {
        id: 6,
        label: "Address",
        type: "text",
        placeholder: "XX:XX:XXX",
    },
    {
        id: 7,
        label: "Country",
        type: "text",
        placeholder: "India",
    },
];

export const productInputs = [
    {
        id: 1,
        label: "Title",
        type: "text",
        placeholder: "Apple Macbook Pro",
    },
    {
        id: 2,
        label: "Description",
        type: "text",
        placeholder: "Description",
    },
    {
        id: 3,
        label: "Category",
        type: "text",
        placeholder: "Computers",
    },
    {
        id: 4,
        label: "Price",
        type: "text",
        placeholder: "100",
    },
    {
        id: 5,
        label: "Stock",
        type: "text",
        placeholder: "in stock",
    },
];
